export const MENU_SOURCE_ACCEPT = 'application/pdf,.pdf,image/jpeg,image/png,image/webp,image/gif,.jpg,.jpeg,.png,.webp,.gif,.csv,.tsv,.txt,.html,.htm,.json,.md,.xml,.yaml,.yml';

export const isPdfMenuSource = (file) => file.type === 'application/pdf' || /\.pdf$/i.test(file.name || '');

export async function uploadMenuSourceFile({ siteId, file }) {
  if (!siteId) throw new Error('Select a site first.');
  if (file.size > 20 * 1024 * 1024) throw new Error(`${file.name} exceeds the 20 MB menu source limit.`);
  const token = localStorage.getItem('token');
  if (!token) throw new Error('Please log in again.');
  const headers = { Authorization: `Bearer ${token}` };
  const kind = isPdfMenuSource(file) ? 'document' : 'image';
  const presign = await fetch(`/api/uploads/presign?kind=${kind}&filename=${encodeURIComponent(file.name)}&siteId=${encodeURIComponent(siteId)}`, { headers });
  if (!presign.ok) throw new Error(`Could not prepare ${file.name} for upload.`);
  const { url, key } = await presign.json();
  if (!url || !key) throw new Error('Invalid upload URL response.');
  const fileType = kind === 'document' ? 'application/pdf' : file.type || 'application/octet-stream';
  const upload = await fetch(url, { method: 'PUT', headers: { 'Content-Type': fileType }, body: file });
  if (!upload.ok) throw new Error(`Could not upload ${file.name}.`);
  const finalize = await fetch('/api/uploads/finalize', {
    method: 'POST', headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify({ filename: file.name, fileType, key, siteId, title: file.name }),
  });
  if (!finalize.ok) throw new Error(`Could not save ${file.name} in the asset library.`);
  const { asset } = await finalize.json();
  if (!asset?.id) throw new Error('Upload completed but no asset was returned.');
  return { id: Number(asset.id), title: file.name, filename: file.name };
}

export async function readMenuSourceFile(file) {
  if (!/\.(csv|tsv|txt|html?|json|md|xml|ya?ml)$/i.test(file.name || '') && !String(file.type || '').startsWith('text/')) {
    throw new Error(`Unsupported menu source: ${file.name}. Use a PDF, JPEG, PNG, WebP, GIF or text file.`);
  }
  if (file.size > 240000) throw new Error(`${file.name} is too long. Use at most 60,000 characters per text source.`);
  const text = await file.text();
  if (text.length > 60000) throw new Error(`${file.name} is too long. Use at most 60,000 characters per text source.`);
  if (!text.trim()) throw new Error(`${file.name} contains no menu text.`);
  return { title: file.name, filename: file.name, mimeType: file.type || 'text/plain', text };
}
